import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetGameListTableData } from '@/modules/game/type'
import GameListTable from '../GameListTable'
import { Button } from '@/common/ui/button'
import { useMutationGameSync } from '@/modules/game/api/hooks/useMutationGameSync'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'

interface GameListListingProps {
	data: GetGameListTableData[]
	isLoading?: boolean
	total: number
	refetch: () => void
}

export default function GameListListing({
	data,
	isLoading,
	total,
	refetch,
}: GameListListingProps) {
	const { mutate: syncGames, isPending } = useMutationGameSync({
		onSuccess: () => {
			refetch()
			toast.success('sync เกมสำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleSync = () => {
		syncGames()
	}

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`รายชื่อเกมทั้งหมด`} description="รายชื่อเกมทั้งหมด" />
				<AlertDialog>
					<AlertDialogTrigger asChild>
						<Button variant="destructive" size="lg" disabled={isPending}>
							{isPending ? 'กำลัง sync...' : 'sync เกม'}
						</Button>
					</AlertDialogTrigger>
					<AlertDialogContent>
						<AlertDialogHeader>
							<AlertDialogTitle>ยืนยันการ Sync เกม</AlertDialogTitle>
							<AlertDialogDescription>
								คุณต้องการที่จะ sync เกมใช่หรือไม่?
								การดำเนินการนี้จะอัพเดทรายการเกมทั้งหมด
							</AlertDialogDescription>
						</AlertDialogHeader>
						<AlertDialogFooter>
							<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
							<AlertDialogAction onClick={handleSync} disabled={isPending}>
								{isPending ? 'กำลัง sync...' : 'ยืนยัน'}
							</AlertDialogAction>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialog>
			</div>
			<Separator />
			<GameListTable data={data} isLoading={isLoading} total={total} />
		</div>
	)
}
